import { HttpErrorResponse } from '@angular/common/http';

import { createSelector } from '@ngrx/store';

import { ElementsWithSignature, hotspotToSignature } from '@recruitee/integrations-http';
import { Hotspot } from '@recruitee/integrations-types';
import { createEntityCollectionStore, memoizeSelector, pipeState } from '@recruitee/ngrx';
import { wrapToArray } from '@recruitee/utils';

const idSelector = ({ signature }: { signature: string }) => signature;
const { actions, namespace, reducer, selectors } =
  createEntityCollectionStore<ElementsWithSignature>()('integration-elements', {
    idSelector,
    customActions: adapter => ({
      fetchCollection: (state, payload: Hotspot | Hotspot[]) =>
        adapter.markAsPending(state, {
          scope: null,
          entities: wrapToArray(payload).map(item => hotspotToSignature(item)),
        }),
      fetchCollectionSuccess: (state, payload: ElementsWithSignature[]) =>
        pipeState(
          state,
          next => adapter.writeMany(next, payload),
          next =>
            adapter.markAsLoaded(next, {
              scope: null,
              entities: payload.map(({ signature }) => signature),
            }),
        ),
      fetchCollectionFailed: (state, payload: { error: HttpErrorResponse; hotspots: Hotspot[] }) =>
        adapter.setError(state, {
          scope: null,
          entities: payload.hotspots.map(hotspot => hotspotToSignature(hotspot)),
        }),
    }),
  });

// const IntegrationElementsActions: Pick<
//   typeof actions,
//   'fetchCollection' | 'fetchCollectionSuccess' | 'fetchCollectionFailed'
// > = actions;

const IntegrationElementsSelectors = {
  byHotspot: memoizeSelector((hotspot: Hotspot) =>
    createSelector(
      selectors.entityMap,
      entityMap => entityMap[hotspotToSignature(hotspot)]?.elements,
    ),
  ),
  metaByHotspot: memoizeSelector((hotspot: Hotspot) =>
    createSelector(
      selectors.entityMetaMap,
      entityMetaMap => entityMetaMap[hotspotToSignature(hotspot)],
    ),
  ),
};

export {
  actions as IntegrationElementsActions,
  namespace as IntegrationElementsNamespace,
  reducer as IntegrationElementsReducer,
  IntegrationElementsSelectors,
};
